import formatCustomText from "activityModule/utils/formatCustomTxt";
import { IDMCActivityWTourOptions } from "commonFnBcode/types/dmc.types";
import React from "react";

function ManageActivityCard({
  activity,
  setEditActivity,
}: {
  activity: IDMCActivityWTourOptions;
  setEditActivity: (activity: IDMCActivityWTourOptions) => void;
}) {
  return (
    <div key={activity.id} className="col-12 mb-3">
      <div className="card shadow-sm border">
        <div className="card-body">
          <div className="row align-items-center">
            <div className="col-md-8">
              <div className="d-flex align-items-center gap-3">
                <div>
                  <h5 className="card-title text-dark mb-1">{activity.name}</h5>
                  {activity.description && (
                    <p className="card-text text-muted mb-2">
                      {formatCustomText(activity.description, true).slice(
                        0,
                        120
                      )}
                      ...
                    </p>
                  )}
                  <div className="d-flex align-items-center gap-3">
                    <small className="text-muted">ID: {activity.id}</small>
                    {activity.priority && (
                      <small className="text-muted">
                        Priority: {activity.priority}
                      </small>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex align-items-center justify-content-md-end gap-2">
                <span
                  className={`badge ${
                    activity.isActive ? "bg-success" : "bg-secondary"
                  }`}
                >
                  {activity.isActive ? "Active" : "Inactive"}
                </span>
                {activity.isTransferRequired && (
                  <span className="badge bg-danger">Transfer Required</span>
                )}
                <button
                  type="button"
                  className="btn btn-flat btn-outline-primary btn-sm"
                  title="Edit Activity"
                  onClick={() => setEditActivity(activity)}
                >
                  <i className="fas fa-edit"></i>
                </button>
              </div>
            </div>
          </div>
          {activity.area && (
            <div className="mt-2">
              <small className="text-muted">
                <i className="fas fa-location-arrow me-1"></i>
                Area: {activity.area.name}
              </small>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ManageActivityCard;
